import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import Axios from 'axios';
import api from '../../services/api';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router-dom';
import './styles.css';

function AutorizacaoOperacao({ onSubmit }) {

	const history = useHistory();

	const [cnpj, setCnpj] = useState('');
	const [razaoSocial, setRazaoSocial] = useState('');
	const [email, setEmail] = useState('');
	const [cep, setCep] = useState('');
	const [logradouro, setLogradouro] = useState('');
	const [numero, setNumero] = useState('');
	const [complemento, setComplemento] = useState('');
	const [bairro, setBairro] = useState('');
	const [cidade, setCidade] = useState('');
	const [uf, setUf] = useState('');
	const [declaracaoCao, setDeclaracaoCao] = useState('');
	const [senha, setSenha] = useState('');
	const [telefone, setTelefone] = useState('');

	const handleCheckboxChange = (e) => {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		setDeclaracaoCao(value);
	}

	const handleCepChange = async (e) => {
		e.preventDefault();
		const value = e.target.value;
		setCep(value);

		let cep = (value.replace(/\D+/g, ''));

		if (cep.length === 8) {
			var response = await Axios.get("https://viacep.com.br/ws/" + cep.replace(/\D+/g, '') + "/json/");
			console.log(response.data);
			if (response.data != null) {
				setLogradouro(response.data.logradouro);
				setBairro(response.data.bairro);
				setCidade(response.data.localidade);
				setUf(response.data.uf);
			};
		};
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		var dados = ({
			cnpj: cnpj.replace(/\D+/g, ''),
			razaoSocial,
			email,
			endereco:{
				cep: cep.replace(/\D+/g, ''),
				logradouro,
				numero,
				complemento,
				bairro,
				cidade,
				uf
			},
			declaracaoCao,
			senha,
			contato: telefone.replace(/\D+/g, ''),
		});

		salvar(dados);

		setCnpj('');
		setRazaoSocial('');
		setEmail('');
		setDeclaracaoCao('');
		setSenha('');
		//setEndereco({});
		setCep('');
		setLogradouro('');
		setNumero('');
		setComplemento('');
		setBairro('');
		setCidade('');
		setUf('');
		//setContato({});
		setTelefone('');
	}

	const salvar = async (dados) => {
		try {
			await api.post("/autorizacao-operacao", dados);
			alert("Cadastro efetuado com sucesso!");
			history.push('/login');
		} catch (error) {
			console.log(error);
			alert("Erro na requisição!");
		}
	};

	return (
		<form onSubmit={handleSubmit} className="cadastro">
			<h1 className="title">
				Cadastro
			</h1>
			<h2 className="subtitle">
				Solicitar Autorização de Operação
			</h2>

			<div className="field">
				<label className="label" htmlFor="cnpj">Cnpj</label>
				<div className="control">
					<InputMask
						id="cnpj"
						name="cnpj"
						className="input"
						required
						value={cnpj}
						mask="99.999.999/9999-99"
						onChange={e => setCnpj(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="razaoSocial">Razão Social</label>
				<div className="control">
					<input
						id="razaoSocial"
						name="razaoSocial"						
						className="input"
						required
						value={razaoSocial}
						onChange={e => setRazaoSocial(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="email">E-mail</label>
				<div className="control">
					<input
						id="email"
						name="email"
						type="email"
						className="input"
						required
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="telefone">Telefone</label>
				<div className="control">
					<InputMask
						id="telefone"
						name="telefone"						
						className="input"
						required
						value={telefone}
						mask="(99) 99999-9999"
						onChange={e => setTelefone(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="cep">CEP</label>
				<div className="control">
					<InputMask
						id="cep"
						name="cep"						
						className="input"
						required
						value={cep}
						mask="99.999-999"
						onChange={handleCepChange}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="logradouro">Logradouro</label>
				<div className="control">
					<input
						id="logradouro"
						name="logradouro"						
						className="input"
						required
						value={logradouro}
						onChange={e => setLogradouro(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="numero">Número</label>
				<div className="control">
					<input 
						id="numero"
						name="numero"
						type="number"						
						className="input"
						required
						value={numero}
						onChange={e => setNumero(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="complemento">Complemento</label>
				<div className="control">
					<input
						id="complemento"
						name="complemento"						
						className="input"
						value={complemento}
						onChange={e => setComplemento(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="bairro">Bairro</label>
				<div className="control">
					<input
						id="bairro"
						name="bairro"						
						className="input"
						required
						value={bairro}
						onChange={e => setBairro(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="cidade">Cidade</label>
				<div className="control">
					<input
						id="cidade"
						name="cidade"						
						className="input"
						required
						value={cidade}
						onChange={e => setCidade(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="uf">UF</label>
				<div className="control">
					<input
						id="uf"
						name="uf"						
						className="input"
						required
						value={uf}
						onChange={e => setUf(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="senha">Senha</label>
				<div className="control">
					<input 
						id="senha"
						name="senha"
						type="password"
						className="input"
						required
						value={senha}
						onChange={e => setSenha(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<div className="control">
					<label className="checkbox">
						<input
							id="declaracaoCao"
							type="checkbox"
							checked={declaracaoCao}
							onChange={handleCheckboxChange}
						/> Declaração conforme o Inciso IX do Art. 4º da Lei Nº 7.225, de 14 de Outubro de 2019.
          </label>
				</div>
			</div>

			<div className="field is-grouped">
				<p className="control">
					<button className="button is-success" type="submit">
						Salvar
          </button>
				</p>
				<p className="control">
					<Link to={`/login`} className="button is-light">Já tenho usuário</Link>
				</p>
			</div>
		</form>
	);

}

export default AutorizacaoOperacao;